

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// GETALLACTIVETIERS
// GETALLACTIVETIERS
const GETALLACTIVETIERS= createAsyncThunk(
  "getAllActiveTiers/getAllActiveTiers",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllActiveTiersSlice = createSlice({
  name: "getAllActiveTiersSlice",
  initialState: {
    getAllActiveTiers: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllActiveTiers: (state) => {
        state.getAllActiveTiers.loading = false
        state.getAllActiveTiers.error = false
        state.getAllActiveTiers.data = []
        state.getAllActiveTiers.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLACTIVETIERS.fulfilled, (state, action) => {
      state.getAllActiveTiers = {
        ...state.getAllActiveTiers,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLACTIVETIERS.pending, (state, action) => {
      state.getAllActiveTiers = {
        ...state.getAllActiveTiers,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLACTIVETIERS.rejected, (state, action) => {
      state.getAllActiveTiers = {
        ...state.getAllActiveTiers,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllActiveTiersAction = {
    GETALLACTIVETIERS,
};

export { getAllActiveTiersAction };
export default getAllActiveTiersSlice.reducer;
export const {setInitialStateOfgetAllActiveTiers} = getAllActiveTiersSlice.actions
